export default "__VITE_ASSET__9e0f81ff__"